<sbnb-loading-spinner *ngIf="loading$ | async" class="py-9"></sbnb-loading-spinner>
<ng-container *ngIf="pricingFeeDiscountData$ | async as feeDiscountData">
  <div data-element="fees-taxes-discounts-container" class="fees-taxes-discounts-container">
    <div class="rule__section-container" *ngIf="!section || section === 'security-deposit'">
      <div class="flex items-center justify-between gap-3 mb-4">
        <h3 class="flex-1" id="security-deposit">
          <div class="flex items-center gap-4">
            <span>Security deposit</span>
          </div>
        </h3>
        <sbnb-save-indicator [saveStatus]="(priceSaveState$ | async)?.securityDeposits"></sbnb-save-indicator>
      </div>

      <div class="flex items-center gap-3 security-deposit-container">
        <span class="flex-1 fee-label">
          Airbnb deposit amount
          <span class="text-xs text-night-lighter">
            <br />
            This will be communicated to the Airbnb guest during checkout. It must be collected manually as an offline
            payment.
            <a
              class="link"
              href="https://help.hospitable.com/en/articles/6262321-security-deposits-for-airbnb"
              target="_blank">
              Learn more
            </a>
          </span>
        </span>

        <sbnb-icon-airbnb [size]="12"></sbnb-icon-airbnb>
        <mat-form-field class="nopadding input__mini">
          <input
            matInput
            type="tel"
            maxlength="6"
            autocomplete="off"
            placeholder=""
            [(ngModel)]="feeDiscountData['security_deposit'].value"
            (change)="savePriceChange('security_deposit', feeDiscountData['security_deposit'])" />
          <span matSuffix>{{ property.currency }}</span>
        </mat-form-field>
      </div>

      <div class="flex items-center gap-3 security-deposit-container">
        <span class="flex-1 fee-label">
          {{
            (featureFlagDirectSecurityDepositsEnabled$ | async)
              ? 'Direct security deposit amount'
              : 'Direct deposit amount'
          }}
          <span class="text-xs text-night-lighter">
            <br />
            {{
              (featureFlagDirectSecurityDepositsEnabled$ | async)
                ? "We'll collect the security deposit automatically 2 days before check-in and release it 2 days after check-out. Guests are notified automatically."
                : 'This can be communicated to Direct guests using a shortcode. It must be collected manually as an offline payment.'
            }}
          </span>
        </span>

        <sbnb-property-update-status
          [edited]="feeDiscountData['direct_security_deposit'].edited"
          [hasAirbnbListing]="false"></sbnb-property-update-status>

        <mat-form-field class="input__mini nopadding">
          <input
            matInput
            type="tel"
            maxlength="6"
            autocomplete="off"
            placeholder="0"
            [(ngModel)]="feeDiscountData['direct_security_deposit'].value"
            (change)="savePriceChange('direct_security_deposit', feeDiscountData['direct_security_deposit'])" />
          <span matSuffix>{{ property.currency }}</span>
        </mat-form-field>
      </div>
    </div>

    <div class="rule__section-container" *ngIf="!section || section === 'occupancy-based'">
      <div class="flex items-center justify-between gap-3 mb-4">
        <h3 class="flex-1" id="fees">Occupancy based</h3>
        <sbnb-save-indicator [saveStatus]="(priceSaveState$ | async)?.occupancyBased"></sbnb-save-indicator>
      </div>

      <div *ngFor="let occupancy of occupancyBased" class="flex items-center gap-3 mb-2">
        <span class="flex-1 fee-label">
          {{ occupancy.label }}
          <span *ngIf="occupancy.description" class="text-xs text-night-lighter">
            <br />
            {{ occupancy.description }}
          </span>
        </span>

        <sbnb-property-update-status
          [edited]="feeDiscountData[occupancy.key].edited"
          [hasAirbnbListing]="property.counts?.airbnb > 0"></sbnb-property-update-status>

        <mat-form-field class="input__mini nopadding" [disabled]="occupancy.key === 'maximum_occupancy'">
          <input
            matInput
            type="tel"
            maxlength="6"
            autocomplete="off"
            placeholder="0"
            [(ngModel)]="feeDiscountData[occupancy.key].value"
            (change)="savePriceChange(occupancy.key, feeDiscountData[occupancy.key])"
            [disabled]="occupancy.key === 'maximum_occupancy'"
            [matTooltip]="occupancy.key === 'maximum_occupancy' ? 'Update in property details' : ''" />
          <span matSuffix>{{ occupancy.key === 'price_per_extra_person' ? property.currency : 'Guests' }}</span>
        </mat-form-field>
      </div>
    </div>
    <ng-container *ngIf="!section || section === 'fees'">
      <div class="rule__section-container" *ngIf="(featureFlagAirbnbFeesEnabled$ | async) !== true; else airbnbFees">
        <div class="flex items-center justify-between gap-3 mb-4">
          <h3 class="flex-1" id="fees">Fees</h3>
          <sbnb-save-indicator [saveStatus]="(priceSaveState$ | async)?.fees"></sbnb-save-indicator>
        </div>

        <div *ngFor="let fee of fees" class="flex items-center gap-3 mb-2">
          <span class="flex-1 fee-label">
            {{ fee.label }}
            <span *ngIf="fee.description" class="text-xs text-night-lighter">
              <br />
              {{ fee.description }}
            </span>
          </span>

          <sbnb-property-update-status
            [edited]="feeDiscountData[fee.key].edited"
            [hasAirbnbListing]="property.counts?.airbnb > 0"></sbnb-property-update-status>

          <mat-form-field class="input__mini nopadding">
            <input
              matInput
              type="tel"
              maxlength="6"
              autocomplete="off"
              placeholder="0"
              [(ngModel)]="feeDiscountData[fee.key].value"
              (change)="savePriceChange(fee.key, feeDiscountData[fee.key])" />
            <span
              *ngIf="fee.fixed || fee.percentage"
              matSuffix
              class="text-xs"
              [class.suffix-bg]="fee.fixed && fee.percentage"
              [class.pointer-events]="fee.fixed === false || fee.percentage === false"
              [matMenuTriggerFor]="typeMenu">
              {{ feeDiscountData[fee.key].type === 'fixed' ? property.currency : '%' }}
              <img
                *ngIf="fee.fixed && fee.percentage"
                class="clickable"
                style="width: 12px; margin-left: 4px"
                src="/assets/images/down-arrow.svg" />
            </span>

            <mat-menu #typeMenu="matMenu">
              <button
                mat-menu-item
                (click)="feeDiscountData[fee.key].type = 'fixed'; savePriceChange(fee.key, feeDiscountData[fee.key])">
                {{ property.currency }}
              </button>
              <button
                mat-menu-item
                (click)="feeDiscountData[fee.key].type = 'percent'; savePriceChange(fee.key, feeDiscountData[fee.key])">
                %
              </button>
            </mat-menu>
          </mat-form-field>
        </div>
      </div>
    </ng-container>

    <ng-template #airbnbFees>
      <div class="rule__section-container">
        <div class="flex items-center justify-between gap-3 pr-4 mb-4">
          <h3 class="flex-1" id="fees">Fees</h3>
          <sbnb-save-indicator [saveStatus]="(priceSaveState$ | async)?.fees"></sbnb-save-indicator>
        </div>

        <div *ngFor="let fee of fees" class="flex items-center gap-3 mb-2">
          <span class="flex-1 fee-label">
            {{ fee.label }}
            <span *ngIf="fee.description" class="text-xs text-night-lighter">
              <br />
              {{ fee.descriptionFeatureFlag ?? fee.description }}
            </span>
          </span>

          <sbnb-property-update-status
            [edited]="feeDiscountData[fee.key].edited"
            [hasAirbnbListing]="property.counts?.airbnb > 0"></sbnb-property-update-status>

          <mat-form-field class="input__mini nopadding">
            <input
              matInput
              type="tel"
              maxlength="6"
              autocomplete="off"
              placeholder="0"
              [(ngModel)]="feeDiscountData[fee.key].value"
              (change)="savePriceChange(fee.key, feeDiscountData[fee.key])" />
            <span
              *ngIf="fee.fixed || fee.percentage"
              matSuffix
              class="text-xs"
              [class.suffix-bg]="fee.fixed && fee.percentage"
              [class.pointer-events]="fee.fixed === false || fee.percentage === false"
              [matMenuTriggerFor]="typeMenu">
              {{ feeDiscountData[fee.key].type === 'fixed' ? property.currency : '%' }}
              <img
                *ngIf="fee.fixed && fee.percentage"
                class="clickable"
                style="width: 12px; margin-left: 4px"
                src="/assets/images/down-arrow.svg" />
            </span>
          </mat-form-field>

          <mat-menu #typeMenu="matMenu">
            <button
              mat-menu-item
              (click)="
                feeDiscountData[fee.key].type = 'fixed';
                invlidateIncompatibleCalculationType(fee.key, feeDiscountData[fee.key], 'fixed');
                savePriceChange(fee.key, feeDiscountData[fee.key])
              ">
              {{ property.currency }}
            </button>
            <button
              mat-menu-item
              (click)="
                feeDiscountData[fee.key].type = 'percent';
                invlidateIncompatibleCalculationType(fee.key, feeDiscountData[fee.key], 'percent');
                savePriceChange(fee.key, feeDiscountData[fee.key])
              ">
              %
            </button>
          </mat-menu>

          <mat-form-field class="input__mini nopadding" *ngIf="fee.calculationTypes">
            <mat-select
              [disabled]="fee.calculationTypes.length === 1"
              [(ngModel)]="feeDiscountData[fee.key].calculation_type"
              (selectionChange)="savePriceChange(fee.key, feeDiscountData[fee.key])">
              <mat-option
                *ngFor="let calculationType of fee.calculationTypes"
                [value]="calculationType.value"
                [disabled]="!calculationType[feeDiscountData[fee.key].type]">
                {{ calculationType.label }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </ng-template>

    <div class="rule__section-container" *ngIf="!section || section === 'discounts'">
      <div class="flex items-center justify-between gap-3 mb-4">
        <h3 class="flex-1" id="discounts">Discounts</h3>
        <sbnb-save-indicator [saveStatus]="(priceSaveState$ | async)?.discounts"></sbnb-save-indicator>
      </div>
      <ng-container *ngFor="let discount of discounts">
        <ng-container [ngSwitch]="discount.key">
          <ng-container *ngSwitchDefault>
            <div class="flex items-center gap-3 mb-2">
              <span class="flex-1 fee-label">
                {{ discount.label }}
                <span *ngIf="discount.description" class="text-xs text-night-lighter">
                  <br />
                  {{ discount.description }}
                </span>
              </span>
              <sbnb-property-update-status
                [edited]="feeDiscountData[discount.key].edited"
                [hasAirbnbListing]="property.counts?.airbnb > 0"></sbnb-property-update-status>
              <mat-form-field class="nopadding input__mini">
                <input
                  matInput
                  type="tel"
                  maxlength="6"
                  autocomplete="off"
                  placeholder="0"
                  [(ngModel)]="feeDiscountData[discount.key].value"
                  (change)="savePriceChange(discount.key, feeDiscountData[discount.key])" />
                <span matSuffix>%</span>
              </mat-form-field>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'early_bird_discount'">
            <div
              *ngIf="featureFlagAirbnbDiscountsEnabled$ | async"
              class="flex items-center gap-3 mb-2 flex-col sbnbDesktop:flex-row">
              <span class="flex-1 fee-label self-start">
                {{ discount.label }}
                <span *ngIf="discount.description" class="text-xs text-night-lighter">
                  <br />
                  {{ discount.description }}
                </span>
              </span>
              <div class="self-end">
                <div
                  class="flex items-center gap-3 mb-2 relative"
                  *ngFor="let early of feeDiscountData[discount.key]; let i = index">
                  <sbnb-icon-airbnb
                    [size]="12"
                    [matTooltip]="'This data is periodically refreshed from Airbnb.'"></sbnb-icon-airbnb>
                  <mat-form-field class="nopadding input__mini !w-40">
                    <input
                      matInput
                      type="number"
                      min="1"
                      max="24"
                      autocomplete="off"
                      placeholder="1"
                      [(ngModel)]="early.threshold_days"
                      (change)="checkAndSave(discount.key, feeDiscountData[discount.key])" />
                    <span matSuffix class="whitespace-nowrap">months before</span>
                  </mat-form-field>
                  <mat-form-field class="nopadding input__mini">
                    <input
                      matInput
                      type="number"
                      min="1"
                      max="100"
                      placeholder="0"
                      [(ngModel)]="early.value"
                      (change)="checkAndSave(discount.key, feeDiscountData[discount.key])" />
                    <span matSuffix>%</span>
                  </mat-form-field>
                  <sbnb-close
                    class="discount-clear-button"
                    (click)="removeDiscount(discount.key, feeDiscountData[discount.key], i)"></sbnb-close>
                </div>
                <div class="flex justify-end">
                  <sbnb-button
                    class="inline-flex items-center gap-2 text-smoke-darker hover:text-smoke-darkest"
                    [type]="'text-secondary'"
                    (click)="addDiscount(feeDiscountData, discount.key)">
                    <span class="text-sm font-medium">+ Add discount</span>
                  </sbnb-button>
                </div>
              </div>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'last_minute_discount'">
            <div
              *ngIf="featureFlagAirbnbDiscountsEnabled$ | async"
              class="flex items-center gap-3 mb-2 flex-col sbnbDesktop:flex-row">
              <span class="flex-1 fee-label self-start">
                {{ discount.label }}
                <span *ngIf="discount.description" class="text-xs text-night-lighter">
                  <br />
                  {{ discount.description }}
                </span>
              </span>
              <div class="self-end">
                <div
                  class="flex items-center gap-3 mb-2 relative"
                  *ngFor="let lastMinuteDiscount of feeDiscountData[discount.key]; let i = index">
                  <sbnb-icon-airbnb
                    [size]="12"
                    [matTooltip]="'This data is periodically refreshed from Airbnb.'"></sbnb-icon-airbnb>
                  <mat-form-field class="nopadding input__mini !w-40">
                    <input
                      matInput
                      type="number"
                      min="1"
                      max="28"
                      autocomplete="off"
                      placeholder="1"
                      [(ngModel)]="lastMinuteDiscount.threshold_days"
                      (change)="checkAndSave(discount.key, feeDiscountData[discount.key])" />
                    <span matSuffix class="whitespace-nowrap">days before</span>
                  </mat-form-field>
                  <mat-form-field class="nopadding input__mini">
                    <input
                      matInput
                      type="number"
                      min="1"
                      max="100"
                      placeholder="0"
                      [(ngModel)]="lastMinuteDiscount.value"
                      (change)="checkAndSave(discount.key, feeDiscountData[discount.key])" />
                    <span matSuffix>%</span>
                  </mat-form-field>
                  <sbnb-close
                    class="discount-clear-button"
                    (click)="removeDiscount(discount.key, feeDiscountData[discount.key], i)"></sbnb-close>
                </div>
                <div class="flex justify-end">
                  <sbnb-button
                    class="inline-flex items-center gap-2 text-smoke-darker hover:text-smoke-darkest"
                    [type]="'text-secondary'"
                    (click)="addDiscount(feeDiscountData, discount.key)">
                    <span class="text-sm font-medium">+ Add discount</span>
                  </sbnb-button>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
    </div>

    <div *ngIf="enableTaxes && !section" class="rule__section-container">
      <div class="flex items-center gap-3 mb-4">
        <h3 class="flex-1" id="taxes">Taxes</h3>
        <sbnb-button type="secondary" size="mini" [routerLink]="['/settings/taxes/name']">+ Add new</sbnb-button>
      </div>

      <ng-container *ngIf="taxes">
        <sbnb-tax-selection [property]="property" [selectedTaxesUuids]="taxesUuids"></sbnb-tax-selection>
      </ng-container>
    </div>

    <!-- Mobile legend for update icons -->
    <div class="rule__section-container md:hidden">
      <div class="flex items-center gap-3 mb-2">
        <sbnb-icon-airbnb [size]="12"></sbnb-icon-airbnb>
        <span>This field periodically refreshes data from Airbnb.</span>
      </div>

      <div class="flex items-center gap-3 mb-2">
        <sbnb-icon-airbnb [size]="12" [muted]="true"></sbnb-icon-airbnb>
        <span>This field does not refresh data from Airbnb.</span>
      </div>

      <div class="flex items-center gap-3">
        <svg
          class="w-3.5 h-3.5"
          matTooltip="This data is pushed to any Direct sites linked to your account."
          width="14"
          height="14"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <rect width="18" height="18" rx="4" fill="#ED3C6A" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.989 11.6926C11.1368 11.6926 12.878 9.97053 12.878 7.84628C12.878 5.72204 11.1368 4 8.989 4C6.84115 4 5.09998 5.72204 5.09998 7.84628C5.09998 9.97053 6.84115 11.6926 8.989 11.6926ZM8.98891 10.1542C10.2776 10.1542 11.3223 9.12097 11.3223 7.84643C11.3223 6.57188 10.2776 5.53866 8.98891 5.53866C7.70021 5.53866 6.6555 6.57188 6.6555 7.84643C6.6555 9.12097 7.70021 10.1542 8.98891 10.1542ZM7.42473 12.4614C6.99988 12.4614 6.65547 12.8058 6.65547 13.2306C6.65547 13.6555 6.99988 13.9999 7.42473 13.9999H10.553C10.9779 13.9999 11.3223 13.6555 11.3223 13.2306C11.3223 12.8058 10.9779 12.4614 10.553 12.4614H7.42473Z"
            fill="white" />
        </svg>
        <span>This field pushes any updates to any Direct Sites.</span>
      </div>
    </div>
  </div>
</ng-container>
